// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { ChoiceContext } from '@digitalasset/utility-operator-api-ts-client';
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { MintRequest } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Model/Mint';
import { ContractId } from '@daml/types';
import { useUtilityRegistryApiClient } from '../../../../../contexts/UtilityRegistryApiContext';

export const useAcceptMintRequestContext: () => UseMutationResult<
  ChoiceContext,
  string,
  {
    mintRequestId: ContractId<MintRequest>;
  }
> = () => {
  const registryApi = useUtilityRegistryApiClient();

  return useMutation({
    mutationKey: ['acceptMintRequestContext', registryApi],
    mutationFn: async ({ mintRequestId }) => {
      return registryApi.getMintRequestAcceptContext(mintRequestId);
    },
  });
};
